export { default as Form } from './Form';
export { FORM_KEY, resolveFormActionFormName } from './_types';
export { LEAD_FORM_NAME } from '@/features/lead-form/constants/formName';
export type {
  FormProps,
  SubmitAction,
  FormField,
  FormKey,
  FormAgreementOptions,
  FormActionFormName,
} from './Form';
export type { LeadFormName } from '@/features/lead-form/constants/formName';

export { FIELDS_AFFILIATE, FIELDS_PARTNERS } from './_config';
export { default as FormPopup, openPopup, openPopupTab, openPopupMulti } from './FormPopup';
export type { FormPopupProps, OpenPopupOptions } from './FormPopup';
export { default as FormLayerPopup } from './FormLayerPopup';
export type { FormLayerPopupProps } from './FormLayerPopup';
export { default as FormPopupContent } from './FormPopupContent';
export type { FormPopupContentProps } from './FormPopupContent';
export { default as AgreementBox } from './common/AgreementBox';
